import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import { Nav, NavItem, NavLink, TabContent, TabPane, Col, Row, Button, Container } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import Autocomplete from '@material-ui/lab/Autocomplete';
import classnames from 'classnames';
import MedicinesPriceListTable from './MedicinesPriceListTable';
import Tooltip from '@material-ui/core/Tooltip';
import Add from '@material-ui/icons/Add';
import MedicinesPriceListTableActions from './MedicinesPriceListTableActions';
import Save from '@material-ui/icons/Save';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { formatNumber } from '../../../Utils/Money';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const PriceListModal = ({
    servicesArray,
    third,
    planThird,
    planServicesActual,
    servicePlan,
    closeModal,
    opened,
    reloadPriceList,
    medicinesArray
}) => {

    //Modal
    const [activeTab, setActiveTab] = useState('1');
    const [openModal, setOpenModal] = useState(opened);
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    //Tab de Informacion del Servicio
    const [service, setService] = useState(null);
    const [price, setPrice] = useState(null);
    const [errors, setErrors] = useState({});
    const [medicineInclude, setMedicineInclude] = useState(false);

    //Tab de Medicamento
    const [errorsMed, setErrorsMed] = useState({});
    const [medicine, setMedicine] = useState(null);
    const [medicinePrice, setMedicinePrice] = useState(null);
    const [unitNumber, setUnitNumber] = useState(1);
    const [medicinesPriceList, setMedicinesPriceList] = useState([]);
    const [editMedicineMode, setEditMedicineMode] = useState(false);

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const closeAlertModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            close();
            reloadPriceList();
        }
    }

    const cleanData = () => {
        setService(null);
        setPrice(null);
        setErrors({});
        setErrorsMed({});
        setMedicine(null);
        setMedicinePrice(null);
        setMedicinesPriceList([]);
    }

    useEffect(() => {
        mountPriceServiceFields();
    }, []);

    const mountPriceServiceFields = () => {
        if (servicePlan != null) {
            let serviceJSON = servicesArray.find(ser => ser.id_servicio == servicePlan.id_servicio);
            if (serviceJSON != null && serviceJSON != undefined) {
                setService(serviceJSON);
                setPrice(servicePlan.costo);
                if (servicePlan.medicamentos != undefined && servicePlan.medicamentos != null) {
                    setMedicinesPriceList(servicePlan.medicamentos);
                }
            }
        }
    }

    const validateFields = () => {
        let errors = {};
        let isError = false;
        if (service == null) {
            errors.service = 'El servicio es Obligatorio';
            isError = true;
        }
        else {
            delete errors.service;
        }
        if (price == null) {
            errors.price = 'El costo del Servicio es Obligatorio';
            isError = true;
        }
        else {
            if (price.includes('.') || price.includes(',')) {
                errors.price = 'Ingrese el valor solo con números';
                isError = true;
            }
            else {
                delete errors.price;
            }
        }
        setErrors(errors);
        return isError;
    }

    const addPrice = async () => {
        let isError = validateFields();
        if (isError) {
            if (activeTab == '2') {
                setActiveTab('1');
            }
            return;
        }

        if (!planServicesActual.some((element) => element.id_servicio == service.id_servicio)) {
            let dataSend = {
                id_tercero: third.id_tercero,
                id_plan: planThird.id_plan,
                id_servicio: service.id_servicio,
                tipo: service.tipo,
                valor: price,
                medicamentos: medicinesPriceList
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                console.log(response.status);
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(data => {
                alertModal(true, "Servicio guardado con exito");
            }).catch((error) => {
                alertModal(false, "Ha ocurrido un error en el servidor");
            });
        } else {
            alertModal(false, "Ya existe el servicio en este plan");
        }
    }

    const updatePrice = async () => {
        let isError = validateFields();
        if (isError) {
            if (activeTab == '2') {
                setActiveTab('1');
            }
            return;
        }

        var dataSend = {
            id_tercero: third.id_tercero,
            id_servicio: service.id_servicio,
            valor: price,
            id_plan: planThird.id_plan,
            tipo: service.tipo,
            medicamentos: medicinesPriceList
        };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error(`Ha ocurrido un error en el servidor`);
            }
        }).then(data => {
            alertModal(true, "Servicio Actualizado Correctamente");
        }).catch((error) => {
            alertModal(false, "Ha ocurrido un error en el sistema");
            console.error('Error:', error);
        });
    }

    const close = () => {
        if (servicePlan == null) {
            cleanData();
        }
        closeModal();
    }

    const handlerChangeService = (ser) => {
        if (ser != null) {
            setService(ser);
        }
        else {
            setService(null);
        }
    }

    const handleChangeServicePrice = (price) => {
        if (price != "" && price != null) {
            setPrice(price);
        }
        else {
            setPrice(null);
        }
    }

    const handlerChangeMedicine = (med) => {
        console.log(med);
        activeEditMedicineMode(null, false);
        if (med != null) {
            setMedicine(med);
        }
        else {
            setMedicine(null);
        }
    }

    const handlerChangeMedicinePrice = (price_med) => {
        if (price_med != null && price_med != "") {
            setMedicinePrice(price_med);
        }
        else {
            setMedicinePrice(null);
        }
    }

    const handleChangeMedicineInclude = (_medicineInclude) => {
        setMedicineInclude(_medicineInclude);
    }

    const validateMedicinePrice = () => {
        console.log(medicinesPriceList);
        let errors = {};
        let isError = false;

        if (medicine == null) {
            errors.medicine = 'El Medicamento es Obligatorio';
            isError = true;
        }
        else {
            //Validacion de si el Medicamento ya se agrego
            let isSaved = medicinesPriceList.some(medi => medi.id_med_stock == medicine.id_med_stock)
            if (isSaved) {
                alertModal(false, "Este medicamento ya fue agregado");
                return true;
            }
            else {
                delete errors.medicine;
            }
        }


        if (medicinePrice == null) {
            errors.medicinePrice = 'El costo del Medicamento es Obligatorio';
            isError = true;
        }
        else {
            if (medicinePrice.includes('.') || medicinePrice.includes(',')) {
                errors.medicinePrice = 'El costo del Medicamento es solo con Números';
                isError = true;
            }
            else {
                delete errors.medicinePrice;
            }
        }

        setErrorsMed(errors);
        return isError;
    }

    const addTempMedicinePrice = () => {
        let isError = validateMedicinePrice(medicine);
        if (isError) {
            return;
        }

        let medSave = {
            id_med_stock: medicine.id_med_stock,
            cod_medicamento: medicine.cod_medicamento,
            unidad_medida: medicine.unidad_medida,
            concentracion: medicine.concentracion,
            forma_farmaceutica: medicine.forma_farmaceutica,
            nom_articulo: medicine.nom_articulo,
            atc: medicine.atc,
            costo: medicinePrice,
            numero_unidades: unitNumber
        }

        setMedicinesPriceList([...medicinesPriceList, medSave]);
    }

    const removeMedicine = (medicineRemoved) => {
        let items = medicinesPriceList.filter(med => med.id_med_stock != medicineRemoved.id_med_stock);
        setMedicinesPriceList(items);
    }

    const activeEditMedicineMode = (dataMed, active) => {
        console.log(dataMed);
        if (dataMed != null) {
            setMedicine(dataMed);
            setMedicinePrice(dataMed.costo);
        }
        setEditMedicineMode(active);
    }

    const ListMedicinesPriceList = (ser) => {
        return (
            <MedicinesPriceListTable
                reactTableData={medicinesPriceList}
                removeMedicine={removeMedicine}
                ReactTableActions={MedicinesPriceListTableActions}
                activeEditMedicineMode={activeEditMedicineMode}
            />)
    }

    const updateMedicinePrice = () => {
        let itemsMedicine = [...medicinesPriceList];
        let indexMed = itemsMedicine.findIndex((medi) => medi.id_med_stock == medicine.id_med_stock);
        let itemMed = { ...itemsMedicine[indexMed] };
        itemMed.costo = medicinePrice;
        itemMed.numero_unidades = unitNumber;
        itemsMedicine[indexMed] = itemMed;
        setMedicinesPriceList(itemsMedicine);
    }

    const getTotalMedicinePrice = () => {
        let totalMedicinePrice = 0;
        for (let i = 0; i < medicinesPriceList.length; i++) {
            totalMedicinePrice = parseFloat(totalMedicinePrice) + (parseFloat(medicinesPriceList[i].costo) * parseFloat(medicinesPriceList[i].numero_unidades));
        }
        return totalMedicinePrice;
    }

    const getTotalPrice = () => {
        let priceService = price != null ? price : 0;
        let totalPriceMedicine = getTotalMedicinePrice();
        let total = parseFloat(priceService) + parseFloat(totalPriceMedicine);
        return total;
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    close();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {servicePlan == null ? <h5 className="bold-text">Agregar Servicio</h5>
                                : <h5 className="bold-text">Actualizar Servicio</h5>
                            }
                        </div>

                        <div className="tabs tabs--justify tabs--bordered-top">
                            <div className="tabs__wrap">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => toggle('1')}
                                            style={{ color: 'black', textDecoration: 'none' }}
                                        >
                                            Información del Costo
                                        </NavLink>
                                    </NavItem>
                                    {
                                        planThird.incluye_medicamento == false ? <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => toggle('2')}
                                                style={{ color: 'black', textDecoration: 'none' }}
                                            >
                                                Medicamentos Requeridos ({medicinesPriceList.length})
                                            </NavLink>
                                        </NavItem> : null
                                    }

                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col md={6}>
                                                <Autocomplete
                                                    noOptionsText='Sin Opciones'
                                                    options={servicesArray}
                                                    onChange={(event, value) => {
                                                        handlerChangeService(value);
                                                    }}
                                                    disabled={servicePlan != null ? true : false}
                                                    value={service}
                                                    id="service-price-list"
                                                    getOptionLabel={(service) => service.codigo + " - " + service.nombre}
                                                    renderInput={(params) => <TextField {...params}
                                                        required={true}
                                                        className="medical-material-form__field"
                                                        InputLabelProps={{
                                                            style: { color: '#646777' }
                                                        }}
                                                        label="Servicios"
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                        helperText={errors.hasOwnProperty("service") && service == null ? errors.service : ""}
                                                        error={errors.hasOwnProperty("service") && service == null ? true : false}
                                                    />}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <TextField
                                                    required={true}
                                                    label="Costo del Servicio"
                                                    value={price}
                                                    type='number'
                                                    onChange={(event) => {
                                                        handleChangeServicePrice(event.target.value);
                                                    }}

                                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                    helperText={errors.hasOwnProperty("price") && (price == null || (price.includes('.') || price.includes(','))) ? errors.price : ""}
                                                    error={errors.hasOwnProperty("price") && (price == null || (price.includes('.') || price.includes(','))) ? true : false}
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col md={6}>
                                                <Autocomplete
                                                    noOptionsText='Sin Opciones'
                                                    options={medicinesArray}
                                                    onChange={(event, value) => {
                                                        handlerChangeMedicine(value);
                                                    }}
                                                    //disabled={servicePlan != null ? true : false}
                                                    value={medicine}
                                                    id="service-price-list"
                                                    getOptionLabel={(med) => med.nom_articulo}
                                                    renderInput={(params) => <TextField {...params}
                                                        required={true}
                                                        className="medical-material-form__field"
                                                        InputLabelProps={{
                                                            style: { color: '#646777' },
                                                            shrink: true
                                                        }}
                                                        label="Medicamento"
                                                        style={{ minWidth: '150px', maxWidth: '100%' }}
                                                        helperText={errorsMed.hasOwnProperty("medicine") && medicine == null ? errorsMed.medicine : ""}
                                                        error={errorsMed.hasOwnProperty("medicine") && medicine == null ? true : false}
                                                    />}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <TextField
                                                    required={true}
                                                    label="Costo"
                                                    value={medicinePrice}
                                                    type='number'
                                                    onChange={(event) => {
                                                        handlerChangeMedicinePrice(event.target.value);
                                                    }}
                                                    style={{ minWidth: '150px', maxWidth: '100%' }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' },
                                                        shrink: true
                                                    }}
                                                    helperText={errorsMed.hasOwnProperty("medicinePrice") && (medicinePrice == null || (medicinePrice.includes('.') || medicinePrice.includes(','))) ? errorsMed.medicinePrice : ""}
                                                    error={errorsMed.hasOwnProperty("medicinePrice") && (medicinePrice == null || (medicinePrice.includes('.') || medicinePrice.includes(','))) ? true : false}
                                                />
                                            </Col>
                                            <Col md={12}>
                                                <br />
                                                {!editMedicineMode ? <Tooltip title="Agregar Medicamento">
                                                    <Button
                                                        style={{ float: 'right' }}
                                                        className="btn btn-sm"
                                                        color="primary"
                                                        onClick={() => { addTempMedicinePrice(); }}>
                                                        <Add />
                                                    </Button>
                                                </Tooltip> : <Tooltip title="Actualizar precio del Medicamento">
                                                    <Button
                                                        style={{ float: 'right' }}
                                                        className="btn btn-sm"
                                                        color="primary"
                                                        onClick={() => {
                                                            updateMedicinePrice();
                                                        }}>
                                                        <Save />
                                                    </Button>
                                                </Tooltip>}
                                            </Col>
                                        </Row>
                                        <ListMedicinesPriceList />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>

                        <div>
                            {/*
                            <div id="dvChkxIncluyeMedicamentos">
                                <FormControlLabel
                                    id={"chkxIncluyeMedicamentos_FormLabel"}
                                    value={medicineInclude}
                                    control={
                                        <MedicalCheckbox
                                            id={"chkxAF"}
                                            checked={medicineInclude}
                                            onChange={(event, check) => {
                                                console.log(check);
                                                handleChangeMedicineInclude(check)
                                            }}
                                            iconStyle={{ fill: 'green' }}
                                        />
                                    }
                                    label={"En la Factura el Servicio incluye los Medicamentos?"}
                                    labelPlacement={"En la Factura el Servicio incluye los Medicamentos?"}
                                />
                            </div>*/}
                            <span><b>Costo del Servicio: $</b>{formatNumber(price != null ? price : 0)}</span>
                            <br />
                            <span><b>Costo Total de Medicamentos: $</b>{formatNumber(getTotalMedicinePrice())}</span>
                            <br />
                            <span><b>Costo Total: $</b>{formatNumber(getTotalPrice())}</span>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                close();
                            }}
                        >
                            Cerrar
                        </Button>
                        {servicePlan == null ? <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addPrice();
                            }}
                        >
                            Crear
                        </Button> : <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                updatePrice();
                            }}
                        >
                            Actualizar
                        </Button>}
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => closeAlertModal(false)}
            />
        </div>
    );
};
export default PriceListModal;
